"use client";

import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import Table from "../../table";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../ui/select";
import { getPatientComplianceHistory } from "../../../services/patient/details";
import styles from "./ComplianceHistoryModal.module.css";

const ComplianceHistoryModal = ({ isOpen, onClose }) => {
  const [periodFilter, setPeriodFilter] = useState("6-months");

  const periodToMonths = {
    "1-month": 1,
    "3-months": 3,
    "6-months": 6,
    "1-year": 12,
  };

  const { data: complianceData, isLoading } = useQuery(
    ["patient-compliance-history", periodFilter],
    () => getPatientComplianceHistory(null, periodToMonths[periodFilter]),
    {
      enabled: isOpen,
      staleTime: 5 * 60 * 1000,
    }
  );

  const columns = [
    {
      key: "month",
      label: "Month",
      alignLeft: true,
    },
    {
      key: "compliance",
      label: "Compliance",
    },
  ];

  const getPeriodLabel = (value) => {
    const labels = {
      "1-month": "1 Month",
      "3-months": "3 Months",
      "6-months": "6 Months",
      "1-year": "1 Year",
    };
    return labels[value] || value;
  };

  // Map API response to table data format
  const tableData = complianceData?.results?.map((item) => ({
    month: item.month,
    compliance: item.display,
  })) || [];

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent className={styles.modalContent}>
        <DialogHeader className={styles.header}>
          <DialogTitle className={styles.title}>Compliance History</DialogTitle>

          <Select
            value={periodFilter}
            onChange={setPeriodFilter}
            className={styles.periodSelect}
          >
            <SelectTrigger className={styles.selectTrigger}>
              <SelectValue>{getPeriodLabel(periodFilter)}</SelectValue>
            </SelectTrigger>

            <SelectContent className={styles.selectContent}>
              <SelectItem value="1-month">1 Month</SelectItem>
              <SelectItem value="3-months">3 Months</SelectItem>
              <SelectItem value="6-months">6 Months</SelectItem>
              <SelectItem value="1-year">1 Year</SelectItem>
            </SelectContent>
          </Select>
        </DialogHeader>

        <div className={styles.divider} />

        <DialogBody className={styles.body}>
          <Table
            columns={columns}
            data={tableData}
            height={280}
            loading={isLoading}
            primaryHeader={true}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

export default ComplianceHistoryModal;